import type React from 'react';
import type { Id as ToastId, ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';
import {
  NotificationRawSnackbar,
  type NotificationRawSnackbarProps,
} from './NotificationRawSnackbar';
import type { NotificationSnackbarProps } from './NotificationSnackbar';
import {
  NotificationSnackbar,
  snackbarDefaultParams,
} from './NotificationSnackbar';
import type { NotifyCallbacks } from './notifyCallbacks';
import { notifyCallbacks } from './notifyCallbacks';

export interface Notify extends NotifyCallbacks {
  snackbar: (
    message: NotificationSnackbarProps,
    params?: ToastOptions
  ) => ToastId;
  snackbarRaw: (
    component: React.ReactNode,
    props?: NotificationRawSnackbarProps,
    params?: ToastOptions
  ) => ToastId;
  /** Remove a given toast by calling toast.dismiss(id), or remove all by calling toast.dismiss() */
  dismiss: typeof toast.dismiss;
}

export const notify: Notify = {
  ...notifyCallbacks,
  snackbar(
    {
      type = 'dark',
      label,
      actionLabel,
      cb,
      hideClose,
      iconName,
      linkCB,
      linkLabel,
    },
    params
  ) {
    return toast[type](
      <NotificationSnackbar
        type={type}
        label={label}
        actionLabel={actionLabel}
        cb={cb}
        hideClose={hideClose}
        iconName={iconName}
        linkCB={linkCB}
        linkLabel={linkLabel}
      />,
      {
        ...snackbarDefaultParams,
        ...params,
      }
    );
  },
  snackbarRaw(component, props, params) {
    return toast(
      <NotificationRawSnackbar {...props}>{component}</NotificationRawSnackbar>,
      {
        ...snackbarDefaultParams,
        ...params,
      }
    );
  },
  dismiss: toast.dismiss,
};
